import React, { FunctionComponent } from "react";

import { DetailedCartItem } from "../../../../../../../../context/CartContext/CartContext.api.types";
// Components
import Header from "./Header";
import MainDetail from "./MainDetail";
// Styles
import "./CartDetailedItemMobile.scss";

type Props = {
  cartDetailedItem: DetailedCartItem;
  onDelete: () => void;
  onEdit: (cartDetailedItem: DetailedCartItem) => void;
  labels: LenghtLabel;
};

const CartDetailedItemComponentMobile: FunctionComponent<Props> = ({
  cartDetailedItem,
  onDelete,
  onEdit,
  labels,
}) => (
  <div className="cart-detailed-item-mobile">
    <Header
      cartDetailedItem={cartDetailedItem}
      onDelete={onDelete}
      onEdit={onEdit}
    />
    {cartDetailedItem.customization ? (
      <p>
        Personalizado: <span>{cartDetailedItem.customization}</span>
      </p>
    ) : null}
    <MainDetail cartDetailedItem={cartDetailedItem} labels={labels} />
  </div>
);

export default CartDetailedItemComponentMobile;
